import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './styles.css';
import { addSpacesAfterSlash, checksIfNoSpaces } from '../../../../../../utils';
import { useScrollingCohorts } from '../../../../../../lib/store/360.store';
import { useMenuBar } from '../../../../../../lib/store/v3/layout';

const Tooltip = (props) => {
  const [active, setActive] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const tooltipRef = useRef(null);
  const wrapperRef = useRef(null);
  const scrolling = useScrollingCohorts((state: any) => state.scrolling);
  const openMenu = useMenuBar((state: any) => state.openMenu);

  useEffect(() => {
    if (openMenu) {
      setActive(false);
    }
  }, [openMenu]);

  const showTip = () => {
    const wrapperRect = (wrapperRef?.current as any)?.getBoundingClientRect();
    setPosition({
      top: wrapperRect.top - 10,
      left: wrapperRect.left + wrapperRect.width / 2
    });
    setActive(true);
  };

  const hideTip = () => {
    setActive(false);
  };

  return (
    <div
      ref={wrapperRef}
      className={`${scrolling ? 'pointer-events-none' : ''} Tooltip-Wrapper font-montserrat z-50`}
      onMouseEnter={showTip}
      onMouseLeave={hideTip}>
      {props.children}
      {active &&
        ReactDOM.createPortal(
          <div
            ref={tooltipRef}
            className={`${
              props.menu
                ? 'Tooltip-menu'
                : props.content.length > 80 && props.expandable360MenuWidth < 440
                ? 'Tooltip-Tip-long'
                : props.content.length < 80
                ? 'Tooltip-Tip-short'
                : 'Tooltip-Tip'
            } px-3 py-0.5 text-[11px] ${props.class || 'ml-24'} ${props.direction || 'top'}`}
            style={{
              top: `${position.top}px`,
              left: `${position.left}px`,
              transform: 'translateX(-50%)'
            }}>
            {props.content}
          </div>,
          document.body
        )}
    </div>
  );
};

export default Tooltip;
